import { Skeleton } from "@/components/ui/skeleton";

export const HeaderSkeleton = () => {
  return (
    <header className="h-16 w-full border-b bg-background">
      <div className="flex h-full items-center justify-between px-6">
        {/* Clinet logo skeleton on the left */}
        <div className="flex items-center gap-2">
          <Skeleton className="h-5 w-24" />
        </div>

        {/* Right side items: notification bell and user initials */}
        <div className="flex items-center gap-4">
          {/* Notification bell skeleton */}
          <Skeleton className="size-9 rounded-md" />
          {/* User initials skeleton */}
          <Skeleton className="size-9 rounded-full" />
        </div>
      </div>
    </header>
  );
};
